<template>
  <div class="products-list">
    <div
      v-masonry
      class="list-container"
      transition-duration="0"
      item-selector=".masonry-item"
      :column-width="masonryColWidth"
      gutter="15"
      fit-width="true"
      stagger="0.03s"
    >
      
      <!-- <BonusCard class="masonry-item" v-if="thisProducts.length > 0" v-masonry-tile /> -->
        
      <ProductsListItem
        v-masonry-tile
        v-for="product in thisProducts"
        :key="product.id"
        :product="product"
        :detailLink="true"
        class="masonry-item"
      />
    </div>

    <div class="empty" v-if="(!products || products.length === 0) && !loading">
      <img src="/assets/images/not-found.png" class="not-found-image" alt="Keine Produkte gefunden">
      <h4>Keine Produkte gefunden</h4>
      <p>
        Unter deinen Angaben können wir keine für dich passenden Produkte
        finden. Setze deine Angaben zurück oder lade die Seite neu und probiere
        es erneut.
      </p>
      <div class="buttons">
        <a
          href="/"
          class="button-primary"
          v-on:click.prevent="resetFilter"
          >Filter zurücksetzen</a
        >
        <a href="/" class="button-light">Seite neu laden</a>
      </div>
    </div>

    <div class="show-more-container" v-if="!showAll">
      <button class="button-primary" v-on:click.prevent="showAll = true">
        Alle Produkte anzeigen
      </button>
    </div>
    
    <div 
      class="visually-hidden"
      role="status"
      aria-live="polite">
      {{ filterAnnouncement }}
    </div>
  </div>
</template>

<script>
const browser = require("browser-size")();
import { mapState, mapMutations, mapGetters } from "vuex";
import ProductsListItem from "@/components/ProductsListItem";
import BonusCard from "@/components/BonusCard";
export default {
  data() {
    return {
      initalCount: 9
    };
  },
  components: { ProductsListItem, BonusCard },
  created() {
    if (this.isMobile) {
      this.initalCount = 4;
    }
  },
  methods: {
    resetFilter() {
      this.$store.commit("SET_FILTERS", []);
    }
  },
  computed: {
    ...mapState(["showAllProducts", "loading", "isMobile"]),
    ...mapGetters(["products", "isMobile"]),
    masonryColWidth() {
      return browser.width <= 340 ? 290 : 345;
    },
    showAll: {
      get() {
        if (this.products.length <= this.initalCount) {
          return true;
        } else {
          return this.showAllProducts;
        }
      },
      set(val) {
        this.$store.commit("SET_SHOW_ALL", true);
      }
    },
    thisProducts() {
      const returnProducts = this.showAll
        ? this.products
        : this.products.slice(0, this.initalCount);
      return returnProducts;
    },
    productsLeft() {
      return this.thisProducts.filter((item, index) => {
        return index === 0 || index % 3 === 0;
      });
    },
    productsMiddle() {
      return this.thisProducts.filter((item, index) => {
        return index === 1 || index % 3 === 1;
      });
    },
    productsRight() {
      return this.thisProducts.filter((item, index) => {
        return index === 2 || index % 3 === 2;
      });
    },
    filterAnnouncement() {
      if (this.loading) {
        return 'Produkte werden gefiltert';
      }
      if (this.products.length === 0) {
        return 'Keine Produkte gefunden';
      }
      return `${this.products.length} Produkte gefunden`;
    },
  }
};
</script>

<style lang="scss">
@import "./ProductsList";
</style>
